import { useCallback, useEffect, useState } from "react";
import { useRemotePrinterContextDispatcher } from "../../context/printer-context/remote-printer-context";
import { authenticationService } from "../../../services/authentication";
import { User } from "../../../context/user";
import { context } from "../../../context/context";
import { MobileLoginQrCode } from "../../../common/model/mobile-login-qr-code";
import { t } from "i18next";
import { GetUserProfileHandler } from "../../../common/cqrs/query/get-user-profile/get-user-profile-handler";
import { useUserSessionContextDispatcher } from "../../../common/context/application-context/user-session-context-provider";

export const useMobileLogin = (rawQrCode: string | undefined) => {
    const remotePrinterContextDispatcher = useRemotePrinterContextDispatcher();
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
    const [isSuccess, setIsSuccess] = useState(false);
    const [userName, setUserName] = useState<string | undefined>(undefined);

    const handleClearErrorMessage = useCallback(() => setErrorMessage(undefined), []);
    const userSessionContextDispatcher = useUserSessionContextDispatcher();

    useEffect(() => {
        if (!rawQrCode) {
            return;
        }

        const mobileQrCode = MobileLoginQrCode.fromJSON(rawQrCode);
        if (!mobileQrCode) {
            setErrorMessage(t("login.qr.invalidQrCode"));

            return;
        }

        (async () => {
            try {

                const response = await authenticationService.loginWithMobileToken(mobileQrCode.mobileToken);
                if (mobileQrCode.printer) {
                    remotePrinterContextDispatcher({
                        action: "set",
                        printerId: mobileQrCode.printer.id,
                        printerName: mobileQrCode.printer.name,
                        isZpl: mobileQrCode.printer.type === "zpl",
                    });
                }

                const user = new User(mobileQrCode.userName, response.access_token, "ds");
                context.setCurrentUser(user);
                const profile = await GetUserProfileHandler();
                await context.initAuthenticatedContextAsync(true, profile);
                userSessionContextDispatcher({
                    action: "authenticate-user",
                    user,
                    profile,
                });

                setIsSuccess(true);
                setUserName(user.name);
            } catch (err) {
                setErrorMessage(t("login.qr.invalidToken"));
            }
        })();
    }, [rawQrCode]);

    return {
        isSuccess,
        userName,
        errorMessage,
        clearErrorMessage: handleClearErrorMessage,
    };
};
